import { Segment } from "semantic-ui-react";
import { DomainTaskTitle } from "./DomainTaskTitleComponent";
import ComingSoonPlaceholder from '../../Assessment/ComingSoonPlaceholder'
import styles from "./DomainTasks.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";

export const FamilyDomainTask1 = (questionCompleter: any) => {
  return {
    header: "Organize A Family Meeting",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.horizontalFlip}`} 
            style={{ backgroundImage: `url(${cdnRoute}FamilyMeeting.jpeg)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Organizing a family meeting to discuss the care of the older
                adult is a vital step in preparedness for their future care. It
                is important to consider a family approach, including blended
                family members, when planning for the older adult's future care.
              </p>
              <p >
                This is a time to discuss how everyone can work together in
                preserving the older adult's independence and dignity in the
                face of possible limitations. It is also a time to learn more
                about the older adult's current physical health, long-term care
                insurance, resources available for his/her care, and the plans
                the older adult has made for advance directives.
              </p>
              <p >
                Some families may find it useful to ask a geriatric care manager
                or other non-family member (clergy member, close family friend)
                to facilitate the discussion.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask2 = (questionCompleter: any) => {
  return {
    header: "Consider A Companion Animal",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.horizontalFlip}`} 
            style={{ backgroundImage: `url(${cdnRoute}Companion.jpg)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                A growing body of evidence suggests that companion animals, such
                as cats and dogs, can make significant contributions to an older
                adult's physical and mental health. If the older adult does not
                already have a pet, you may want to suggest the possible
                advantages (and disadvantages) of inviting an animal into their
                lives.
              </p>
              <p >
                You will need to consider the pet's care needs as well as the
                older adult's health in determining whether a new pet would be
                appropriate. Another consideration is whether animals are
                permitted at their place of residence. Even if the older adult
                does not want a full-time pet, some community agencies provide
                for weekly, short-term pet visits to older adults. Pets are
                often popular visitors to older adults who live in nursing
                facilities, assisted-living residences, and retirement
                communities.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask3 = (questionCompleter: any) => {
  return {
    header: "Crisis and Emergency Planning",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientHorizontal} style={{ backgroundImage: `url(${cdnRoute}CrisisPlanning.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Mentally rehearsing the various ways, you and the older adult
                would respond to a “worst case scenario” can help your family
                prepare carefully for unlikely, but dangerous situations. Spend
                some time with the older adult and consider the safest way to
                react to an impending natural disaster, home invasion, or
                financial scam.
              </p>
              <p >
                Consider also how your family will respond in case the older
                adult experiences a major health event. You may decide you want
                to rehearse an evacuation, for example, or make special
                provisions for a fall or other sudden health event by getting a
                “panic button” or a medical ID bracelet for the older adult.
                Older people are often more affected by catastrophic events,
                like weather conditions common to the geographic area.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask4 = (questionCompleter: any) => {
  return {
    header: "Home Safety Assessment",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientHorizontal} style={{ backgroundImage: `url(${cdnRoute}HomeSafety.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Many preventable accidents occur in the home. With advancing
                age, it is important that environments be free of hazards and
                conducive to optimal safety. Having a safe home can allow the
                older adult to live independently longer.
              </p>
              <p >
                Trained occupational therapists and others can assess home
                safety and make educated recommendations that will decrease the
                likelihood of slips and falls. Sometimes simple rearrangement of
                furniture and rugs and changes in lighting can make dramatic
                differences in the likelihood that an older person can live
                safely in her own home. By setting up an assessment, you can
                feel assured and comfortable that the older adult is living in a
                safe and accessible environment.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask5 = (questionCompleter: any) => {
  return {
    header: "Using Technology",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftXLeftMed} ${styles.horizontalFlip} `} 
            style={{ backgroundImage: `url(${cdnRoute}UsingTechnologyLearnMore1.jpg)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Technology has become a major part of our lives and adapting to this “new” way of life is essential for our 
                senior populations. Modern technology can offer a wide range of benefits to older adults from helping them stay 
                connected to friends and family to providing the convenience of ordering groceries and medications online to be 
                delivered straight to their door. 
              </p>
              <p >
                While there can be some hurdles when it comes to adapting to new technologies, studies have shown that most 
                seniors who learn how to use computers and smart phones enjoy doing so and continue to use them regularly. You, or 
                other tech-savvy friends and family, can help the older adult by teaching them how to use technology and integrate 
                it into their daily life.                
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask6 = (questionCompleter: any) => {
  return {
    header: "Choosing Paid Caregivers",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.horizontalFlip}`} style={{ backgroundImage: `url(${cdnRoute}choosingcaregiver_main.jpg)`, }}>
          <div className={`${styles.domainTaskContent} ${styles.horizontalFlipBackContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Although most care given to seniors is provided by family members, full- or part-time caregivers are often 
                employed to assist with bathing and personal care, mealtimes, transportation, and ensuring the older adult is 
                not alone in the home. Finding competent and compassionate paid caregivers whose work styles and personalities 
                are compatible with the older care recipient can sometimes be challenging. 
              </p>
              <p >
                To avoid difficulties and misunderstandings, it can be useful to identify, before a need for a paid caregiver 
                occurs, the criteria important in such a caregiver. The older adult might prefer a caregiver of one gender or the 
                other, one who is of their same religion or cultural group, or a person with special training and expertise. 
                Consider other qualities as well - whether the person is talkative, smokes, has good references from previous jobs, 
                and is willing and able to take on the necessary tasks. 
              </p>
              <p >
                In a medical crisis it may be hard for the older adult to articulate preferences about a care worker, so it is 
                important to discuss this ahead of time to find caregivers who fit the older adult's needs and preferences.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask7 = (questionCompleter: any) => {
  return {
    header: "Grandparent Relationships",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`} style={{ backgroundImage: `url(${cdnRoute}grandparent_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Grandparents have tremendous potential to bring about positive growth and change in their families. Some 
                grandparents “come to life” when they embrace this role and all that it can encompass. The heart of grand-parenting 
                has five parts: grandparents can share their heritage, set an example, offer an angelic influence of and care and 
                protection, be a leading part of reconciliation, and serve as a teacher.  
              </p>
              <p >
                The role of grandparent may be one of the most rewarding roles an older person has for leaving a legacy. 
                Grand-parenting, if seen as part of a healthy balance of roles in later life, can help the older adult to engage 
                in a productive life review, explore previously unexperienced aspects of the self, maintain a feeling of personal 
                importance despite diminished social roles, and develop a healthy attitude toward death.           
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask8 = (questionCompleter: any) => {
  return {
    header: "Caring for Yourself",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={`${styles.imgGradientHorizontal} ${styles.imgShiftRight}`} style={{ backgroundImage: `url(${cdnRoute}caringforyourself_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Caregiving is hard work, and most caregivers of older adults are their spouses and family members. Sometimes 
                caregivers get so wrapped up in caregiving tasks that they let their own health and well-being deteriorate. 
              </p>
              <p >
                It is important to take breaks from caregiving and to focus on your own mental health. It is often helpful 
                to identify neighbors, church members, or other family members to help share the work so that the primary 
                caregiver can get some rest and refreshment.      
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask9 = (questionCompleter: any) => {
  return {
    header: "Home Maintenance",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic className={styles.imgGradientHorizontal} style={{ backgroundImage: `url(${cdnRoute}homemaintenance_main.jpg)`, }}>
          <div className={styles.domainTaskContent}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                The ability to stay in one's home and age in place is important to many people. But keeping up with home maintenance 
                and repairs can be a difficult task, so it is important for older adults to have a plan in place for home maintenance.  
              </p>
              <p >
                Enlisting friends and family to help with preventive maintenance tasks like changing air filters, insulating doors and               
                windows, inspecting smoke alarms, and cleaning gutters can go a long way in helping to keep up the older adult's home. 
                It's also a good idea to find a reliable handyman to call on for repairs that need a professional hand. Budgeting for 
                things like a regular cleaning service or lawn service can also be incredibly helpful for older adults.
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTask10 = (questionCompleter: any) => {
  return {
    header: "Widowhood Support",
    content: (
      <>
      <Segment basic className={styles.domainTaskSegment} >
        <Segment basic 
            className={`${styles.imgGradientHorizontal} ${styles.imgShiftRightMed} `} 
            style={{ backgroundImage: `url(${cdnRoute}widowhood.jpeg)`, }}>
          <div className={`${styles.domainTaskContent}`}>
            <DomainTaskTitle />
            <div className={styles.domainTaskCopy}>
              <p >
                Losing a spouse is an extraordinarily stressful experience, even if anticipated. It is, of course, also stressful 
                for the adult child and other family members. Adult children and others close to the older adult can partially 
                prepare for this event by learning in advance about the dynamics of grief and the typical reactions and behaviors 
                of newly bereaved people. They can also think about the practical supports and companionship their surviving parent 
                may need when death occurs. 
              </p>
              <p >
                Clergy can be very helpful in such preparation and may be able to suggest resources, including groups of bereaved 
                elders in the community, that can support your parent when the time comes. It's also helpful to lean on friends 
                and family members for support as well.                  
              </p>
            </div>
            <div className={styles.domainTaskQuestionContainer}>{questionCompleter}</div>
          </div>
        </Segment>
      </Segment> 
      </>
    ),
  };
};

export const FamilyDomainTaskPlaceholder = () => {
  return {
    header: "Task Coming Soon",
    content: (
      <ComingSoonPlaceholder />
    ),
  };
};
